import Link from "next/link";
import { getLocalizedPath } from "@/components/shared/formatURL";
import React from "react";

interface SubscribeGemsToggleProps {
  containerStyles?: string;
  labelStyles?: string;
  subscribeStyles?: string;
  gemsStyles?: string;
  translations: any;
}

export const SubscribeGemsToggle = ({
  // TODO: clean up styling
  containerStyles = "flex h-[42px] justify-start flex-none w-full sm:justify-center",
  labelStyles = "inline-flex cursor-pointer items-center rounded-lg bg-[#2B2D31] p-1.5",
  subscribeStyles = "px-4 py-1 font-bold text-[#FFCC18]",
  gemsStyles = "rounded-md sm:block bg-[#A24EFF] px-4 py-1 font-bold text-white",
  translations,
}: SubscribeGemsToggleProps) => {
  return (
    <div className={containerStyles}>
      <label className={labelStyles}>
        <Link prefetch={false} href={getLocalizedPath("upgrade")} className={subscribeStyles}>
          {translations.subscribe}
        </Link>
        <Link prefetch={false} href={getLocalizedPath("credits")} className={gemsStyles}>
          {translations.gems}
        </Link>
      </label>
    </div>
  );
};
